import {
  Avatar,
  Badge,
  Card,
  Pane,
  Strong,
  TickCircleIcon,
  Text,
} from "evergreen-ui";
import React from "react";
import { getFormattedDate, getFormattedTime } from "../../util";

export default function RegularBookingCard({
  showBookingDetailsDialog,
  booking,
  index,
  customerDetails,
  bookingStatusIntentMap,
}) {
  return (
    <Card
      id="booking-details"
      key={index}
      position="relative"
      display={"flex"}
      flexDirection={"column"}
      elevation={1}
      width={"95vw"}
      padding={10}
      marginTop={16}
      marginLeft={10}
      marginRight={10}
      onClick={() => showBookingDetailsDialog(booking, index)}
    >
      <Pane display={"flex"} alignItems={"center"}>
        <Avatar name={customerDetails.customerName} size={30} />
        <Pane display={"flex"} justifyContent={"space-between"} width={"100%"}>
          <Strong marginLeft={5}>{customerDetails.customerName}</Strong>
          <Strong textDecoration={"underline"} color={"selected"}>
            {booking.bookingId}
          </Strong>
        </Pane>
      </Pane>
      <Pane
        marginLeft={35}
        marginTop={5}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Strong>{booking["sport"]}</Strong>
        <Badge
          color={bookingStatusIntentMap[booking.bookingStatus.toLowerCase()]}
        >
          {booking?.bookingStatus}
        </Badge>
      </Pane>
      <Pane
        marginLeft={35}
        marginTop={10}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Text color={"muted"}>
          {`${customerDetails["customerMobile"]} |
                            ${customerDetails["customerEmail"]}`}
        </Text>
      </Pane>
      <Pane
        marginLeft={35}
        marginTop={10}
        marginBottom={"20px"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Text color={"muted"}>
          {`${getFormattedDate(
            booking["dateBooked"],
            "YYYY-MM-DD HH:mm:ss",
            "ddd, Do MMM"
          )} |
                            ${getFormattedTime(booking["startTime"])} -
                            ${getFormattedTime(booking["endTime"])}`}
        </Text>
      </Pane>
      {booking?.checkinData === null ? (
        <></>
      ) : (
        <Pane
          position="absolute"
          width={"100%"}
          background="green200"
          bottom={0}
          left={0}
          height={"20px"}
          marginTop={"20px"}
          display="flex"
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <Strong color="#52BD95">Checked In</Strong>{" "}
          <TickCircleIcon color="success" marginLeft={8} />
        </Pane>
      )}
    </Card>
  );
}
